import React from 'react';
import image1 from './img/section4-a.png';
import image2 from './img/section4-b.png';
import image3 from './img/section4-c.png';
import { DiamondIcon } from './HomeschoolComp';
import { ChevronDownIcon, XMarkIcon } from '@heroicons/react/24/outline';
import HomeschoolKIDS from './HomeschoolKIDS';
import { useAppDispatch } from '../../../store/hook';
import { closeModal, openModal } from '../../../store/features/modalSlice';
import HomeschoolBASIC from './HomeschoolBASIC';
import HomeschoolADVANCED from './HomeschoolADVANCED';
import {
  useHomeschoolPrices,
  HomeschoolPriceProvider,
} from './HomeschoolPriceContext';

const HomeschoolSection4 = () => {
  return (
    <div className="m-auto my-20 flex w-full max-w-[480px] flex-col items-center">
      <DiamondIcon color="#ff4f00" width={24} />
      <div className="mt-3 text-center text-3xl md:text-4xl">
        젭스영어교실 연령별 맞춤코스,
        <div className="font-bold">이렇게 구성되어 있어요!</div>
      </div>
      <div className="mt-10 rounded-full bg-black px-4 py-1 font-bold text-white">
        Line up
      </div>
      <CourseButton
        img={image1}
        text={'KIDS 자세히 보기'}
        color={'#ff4f00'}
        Inner={HomeschoolKIDS}
      />
      <CourseButton
        img={image2}
        text={'BASIC 자세히 보기'}
        color={'#ff9b00'}
        Inner={HomeschoolBASIC}
      />

      <CourseButton
        img={image3}
        text={'ADVANCED 자세히 보기'}
        color={'#309c5b'}
        Inner={HomeschoolADVANCED}
      />
    </div>
  );
};

const CourseButton = ({
  img,
  text,
  color,
  Inner,
}: {
  img: string;
  text: string;
  color: string;
  Inner: () => React.JSX.Element;
}) => {
  const dispatch = useAppDispatch();
  const openPopup = () => {
    if (!Inner) {
      alert('준비중입니다.');
      return;
    }
    dispatch(openModal({ body: <Popup Inner={Inner} /> }));
  };
  return (
    <div className="mt-5 w-full rounded-lg bg-white p-5" style={{ color }}>
      <div
        className="group flex cursor-pointer flex-col items-center"
        onClick={openPopup}
      >
        <img
          src={img}
          alt="icon"
          className="mb-[-16px] w-[200px] transform transition-transform duration-100 group-hover:scale-110"
        />
        <div
          className="ml-3 flex w-full transform items-center justify-center rounded border bg-white p-3 text-lg font-bold shadow-lg transition-transform duration-100 group-hover:scale-100 group-hover:bg-gray1"
          style={{ borderColor: color }}
        >
          {text}
          <ChevronDownIcon
            className={`h-6 w-6 transform ${'rotate-[-90deg]'}`}
          />
        </div>
      </div>
    </div>
  );
};

const Popup = ({ Inner }: { Inner: () => React.JSX.Element }) => {
  const dispatch = useAppDispatch();
  const closePopup = () => {
    dispatch(closeModal());
  };
  return (
    <HomeschoolPriceProvider>
      <div className="relative h-screen w-screen max-w-[520px] pt-10">
        <div className="absolute left-0 top-0 flex w-full justify-end bg-black">
          <XMarkIcon
            className="h-10 w-10 cursor-pointer text-white hover:text-gray5"
            onClick={closePopup}
          />
        </div>
        <div className="h-full overflow-y-scroll bg-white">
          <Inner />
        </div>
      </div>
    </HomeschoolPriceProvider>
  );
};

export default HomeschoolSection4;
